import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "@coverme/table";
import * as moment from "moment";
import { Icon } from "@coverme/icons";


export const RetrocheckBillingTable = ({ pagedFiles, onFetchData, isLoading, onDownload,isDownloading }) => {

    const columns = [
        {
            Header: () => <span>File Name</span>,
            sortable: true,
            accessor: "fileName",
            Cell: props => {
                return <span>{props.value}</span>;
            },
        },
        {
            Header: () => <span>Received Date</span>,
            sortable: true,
            accessor: "createdDate",
            width: 250,
            Cell: props => {
                const value =
                    props.value !== undefined && props.value !== null
                        ? moment(props.value).format("MM/DD/YYYY hh:mm A")
                        : "";
                return <span>{value}</span>;
            },
        },
        {
            Header: () => <span>Status</span>,
            sortable: true,
            accessor: "status",
            width: 150,
            Cell: props => {
                return <span>{props.value}</span>;
            },
        },
        {
            Header: () => <span># Accts with Coverage</span>,
            sortable: true,
            style: {
                justifyContent: "center",
            },
            accessor: "numberOfRecords",
            width: 200,
            Cell: props => {
                return <span>{props.value}</span>;
            },
        },
        {
            Header: () => <span>Coverage Found %</span>,
            style: {
                justifyContent: "center",
            },

            sortable: true,
            accessor: "percentageOfCoverageFound",
            width: 200,
            Cell: props => {
                return <span>{props.value}</span>;
            },
        },
        {
            Header: () => <span>Due-payment collected</span>,
            sortable: true,
            style: {
                justifyContent: "center",
            },

            accessor: "percentageOfCoverageFound",
            width: 150,
            Cell: props => {
                return <span>{props.value}</span>;
            },
        },
        {
            Header: () => <span>Actions</span>,
            headerClassName: "",
            sortable: false,
            accessor: "globalId",
            width: 100,
            style: {
                justifyContent: "center",
            },
            Cell: props => {
                return (
                    <button
                        className="download-button"
                        onClick={onDownload?.bind(this,props?.original?.internalFileId,props?.original?.fileName)}
                        disabled={isDownloading}
                    >
                        {!isDownloading && <Icon icon={"download"} color={"black"} height={20} width={20} />}
                        {isDownloading && <div className="simple-loader" />}
                    </button>
                );
            },
        },
    ];

    return (
        <div className="my-cases-table">
            <div className="table-container">
                <div className="totalRecordNumber">
                    {pagedFiles.data.data.length > 0 ? pagedFiles.data?.totalRecordNumberInQuery : 0} Results Found
                </div>
                <Table
                    data={pagedFiles.data.data}
                    defaultSorted={[{ id: "createdDate", desc: true }]}
                    columns={columns}
                    showPagination={true}
                    defaultPageSize={5}
                    manual
                    loading={isLoading}
                    pages={pagedFiles.data.data.length > 0 ? pagedFiles.data.totalNumberOfPages : 1}
                    onFetchData={onFetchData}
                    minRows={1}
                />
            </div>
        </div>
    );
};
